<div class="teaser-container-wrapper">
  <div class="teaser-container teaser-container--3-col">
    <div class="teaser-loader" *ngFor="let teaser of [].constructor(3)">
      <div class="teaser-loader__image">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '0',
            'background-color': '#dfe1e6',
          }"
        ></ngx-skeleton-loader>
      </div>
      <div class="teaser-loader__content">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: '0',
            left: '0',
            'margin-bottom': '0',
            'background-color': '#f9f9fa',
          }"
        ></ngx-skeleton-loader>
        <div class="teaser-loader__badge">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '100%',
              'margin-bottom': '0',
            }"
          ></ngx-skeleton-loader>
        </div>
        <div class="teaser-loader__headline">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '100%',
              'margin-bottom': '0',
            }"
          ></ngx-skeleton-loader>
        </div>
        <div class="teaser-loader__text">
          <div class="teaser-loader__text-firstline">
            <ngx-skeleton-loader
              [theme]="{
                width: '100%',
                height: '100%',
                'margin-bottom': '0',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div class="teaser-loader__text-secondline">
            <ngx-skeleton-loader
              [theme]="{
                width: '100%',
                height: '100%',
                'margin-bottom': '0',
              }"
            ></ngx-skeleton-loader>
          </div>
        </div>
        <div class="teaser-loader__link">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '100%',
              'margin-bottom': '0',
            }"
          ></ngx-skeleton-loader>
        </div>
      </div>
    </div>
  </div>
</div>
